import { ai } from './ai';
import { central } from './central';
import { cues } from './cues';
import { dataUsage } from './data-usage';
import { externals } from './externals';
import { hotspots } from './hotspots';
import { logsGateway } from './logs-gateway';
import { marathon } from './marathon';
import { mediaMetadata } from './media-metadata';
import { onboarding } from './onboarding';
import { playerConfig } from './player-config';
import { search } from './search';
import { status } from './status';
import { streamUsage } from './stream-usage';
import { subtitles } from './subtitles';
import { subtitlesApi } from './subtitles-api';
import { systemEvents } from './system-events';
import { telemetry } from './telemetry';

export const config = {
  ai,
  central,
  cues,
  dataUsage,
  hotspots,
  logsGateway,
  marathon,
  mediaMetadata,
  onboarding,
  playerConfig,
  externals,
  search,
  status,
  streamUsage,
  subtitles,
  subtitlesApi,
  systemEvents,
  telemetry,
};
